<template>
    <Transition name="pop">
        <div id="teamsPop" class="pop" v-if="state.teams.show">
            <div class="content">
                <span class="close" @click="state.teams.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>兄弟团榜</h1>
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>队伍名称</th>
                                <th>队伍人数</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in state.teams.list" :key="item.id">
                                <td>{{ item.team_name }}</td>
                                <td>{{ item.count }}人</td>
                                <td>
                                    <div
                                        class="btn-attend"
                                        @click="joinTeam(item)"
                                    >
                                        加入
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <ul class="pager-wrapper" v-if="state.teams.total > 0">
                        <li v-if="state.teams.page > 1" @click="prevPage">
                            上一页
                        </li>
                        <li
                            v-if="state.teams.page < state.teams.total"
                            @click="nextPage"
                        >
                            下一页
                        </li>
                    </ul>
                    <div class="btn-search" @click="state.search.show = true">
                        搜索兄弟团
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition name="pop">
        <div id="searchPop" class="pop" v-if="state.search.show">
            <div class="content">
                <span class="close" @click="state.search.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>搜索兄弟团</h1>
                <input
                    v-model.trim="state.search.keywords"
                    placeholder="请输入队名/邀请码"
                />
                <div class="btn-confirm" @click="searchEvent">确定</div>
            </div>
        </div>
    </Transition>
    <Transition name="pop">
        <div id="resultsPop" class="pop" v-if="state.results.show">
            <div class="content">
                <span class="close" @click="state.results.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>{{ state.results.team_name }}</h1>
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>角色名称</th>
                                <th>是否团长</th>
                                <th>加入日期</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in state.results.list"
                                :key="index"
                            >
                                <td>{{ item.rolename }}</td>
                                <td>
                                    {{
                                        item.number_type == 1 ? `队长` : `成员`
                                    }}
                                </td>
                                <td>{{ item.team_join_time }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btn-confirm" @click="searchJoin">确认加入</div>
            </div>
        </div>
    </Transition>
    <Transition name="pop">
        <div id="confirmPop" class="pop" v-if="state.confirm.show">
            <div class="content">
                <span class="close" @click="state.confirm.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>确认加入</h1>
                <h3>
                    您确认加入<strong>{{ state.confirm.team.team_name }}</strong
                    >兄弟团？
                </h3>
                <ul>
                    <li @click="state.confirm.show = false">取消</li>
                    <li @click="confirmJoin">确认</li>
                </ul>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive, inject } from "vue";
import { GetBrothers, JoinTeam, GetSearchBrother } from "@/api";
const getMyInfo = inject("getMyInfo");
const limit = 7;
const state = reactive({
    teams: {
        show: false,
        total: 0,
        page: 1,
        list: []
    },
    search: {
        show: false,
        keywords: ""
    },
    results: {
        show: false,
        team_id: "",
        team_name: "",
        list: []
    },
    confirm: {
        show: false,
        team: {}
    }
});

// 获取兄弟团列表
const getBrothers = async () => {
    const res = await GetBrothers(state.teams.page, limit);
    if (res) {
        state.teams.total = Math.ceil(res.total / limit);
        state.teams.list = res.list;
    }
};

// 加入兄弟团
const joinTeam = (team) => {
    state.confirm.team = team;
    state.confirm.show = true;
};

// 搜索加入
const searchJoin = () => {
    if (state.results.list.length >= 5) {
        return CsGame.alert("该兄弟团成员已满！", 1200, "error");
    }
    state.confirm.team = {
        team_id: state.results.team_id,
        team_name: state.results.team_name
    };
    state.confirm.show = true;
};

// 向上分页
const prevPage = async () => {
    if (state.teams.page > 1) {
        state.teams.page--;
        await getBrothers();
    }
};
// 向下分页
const nextPage = async () => {
    if (state.teams.page < state.teams.total) {
        state.teams.page++;
        await getBrothers();
    }
};
// 确定加入兄弟团
const confirmJoin = async () => {
    const res = await JoinTeam(state.confirm.team.team_id);
    if (res) {
        state.teams.show = false;
        state.confirm.show = false;
        state.results.show = false;
        getMyInfo();
        CsGame.alert("加入兄弟团成功！", 1200, "success");
    }
};

// 搜索
const searchEvent = async () => {
    if (!state.search.keywords) {
        return CsGame.alert("请输入搜索关键词！", 1200, "error");
    }
    const res = await GetSearchBrother(state.search.keywords);
    if (res) {
        if (res.list.length > 0) {
            state.search.show = false;
            state.results.show = true;
            state.results.team_id = res.team_id;
            state.results.team_name = res.team_name;
            state.results.list = res.list;
        } else {
            CsGame.alert("没有搜索到任何结果！", 1200, "error");
        }
    }
};

defineExpose({
    Show: async () => {
        state.teams.page = 1;
        await getBrothers();
        state.teams.show = true;
    }
});
</script>

<style lang="scss" scoped>
.pop {
    .table-wrapper {
        font-size: 14px;
        text-align: center;
        table {
            width: 100%;
            th {
                padding: 8px 4px;
                background-color: #7c241e;
                color: #e09e38;
            }
            td {
                padding: 8px 4px;
                border-bottom: 1px solid #cb9443;
                .btn-attend {
                    width: 80px;
                    height: 32px;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                    margin: 0px auto;
                    background-color: #7c241e;
                    color: #e09e38;
                    border-radius: 3px;
                }
            }
        }
        .pager-wrapper {
            display: flex;
            justify-content: center;
            margin: 20px auto 0px auto;
            li {
                width: 80px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                border: 1px solid #7c241e;
                color: #7c241e;
                margin: 0px 10px;
                border-radius: 3px;
                transition: 0.2s;
                &:hover {
                    background: #7c241e;
                    color: #fff;
                }
            }
        }
        .btn-search {
            width: 120px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin: 20px auto 10px auto;
            background-color: #7c241e;
            color: #e09e38;
            border-radius: 3px;
            &::before {
                content: "";
                width: 14px;
                height: 14px;
                background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/search-icon.png");
                background-size: cover;
                margin-right: 4px;
            }
        }
    }
}
#searchPop {
    input {
        width: 360px;
        height: 46px;
        border: 1px solid #7c241e;
        margin: 0px auto;
        display: block;
        background: none;
        text-indent: 1em;
    }
    .btn-confirm {
        width: 240px;
        height: 50px;
        margin: 20px auto 10px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
#resultsPop {
    .btn-confirm {
        width: 240px;
        height: 50px;
        margin: 20px auto 10px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
#confirmPop {
    h3 {
        font-size: 18px;
        text-align: center;
        margin-bottom: 12px;
        display: flex;
        justify-content: center;
        strong {
            color: #3c8a67;
            font-weight: bold;
            margin: 0px 5px;
        }
    }
    ul {
        display: flex;
        justify-content: center;
        padding-top: 10px;
        margin-bottom: 10px;
        li {
            width: 160px;
            text-align: center;
            line-height: 45px;
            height: 45px;
            margin: 0px 10px;
            border-radius: 6px;
            color: #fff;
            cursor: pointer;
            &:nth-of-type(1) {
                background-color: #808080;
            }
            &:nth-of-type(2) {
                background: linear-gradient(to bottom, #86362c, #d6584b);
            }
        }
    }
}
</style>
